import classNames from 'classnames';
import { type ReactElement } from 'react';

import { type ChipTheme } from './chipTheme';
import styles from './chip.module.scss';

export type StaticChipProps = {
  className?: string;
  dataTestId?: string;
  icon?: ReactElement;
  isRounded?: boolean;
  isSmall?: boolean;
  label: string | undefined;
  theme?: ChipTheme;
};

export const StaticChip = ({
  className,
  dataTestId,
  icon,
  isRounded = false,
  isSmall = false,
  label,
  theme,
}: StaticChipProps) => {
  const PARENT_CLASSNAME = 'chip';

  const chipClasses = classNames([
    styles[PARENT_CLASSNAME],
    {
      [styles[`${PARENT_CLASSNAME}--theme-${theme}`]]: theme,
      [styles[`${PARENT_CLASSNAME}--small`]]: isSmall,
      [styles[`${PARENT_CLASSNAME}--is-rounded`]]: isRounded,
    },
    className,
  ]);

  return (
    <div className={chipClasses} data-testid={dataTestId}>
      <span>
        {icon && <div className={styles[`${PARENT_CLASSNAME}__icon-container`]}>{icon}</div>}
        {label}
      </span>
    </div>
  );
};
